'use client'

// imports
import Image from 'next/image';

// lib files
import { DONATE_FALLBACK_URL } from '@/lib/constants';
import { StationData } from "@/lib/types/api/stations-data";

// components
import DonateLinkButton from '@/components/Button/DonateLinkButton';
import StationLogo from '@/components/StationLogo/StationLogo';

// svgs
import ExploringNature from '@/public/staticsvg/exploring_nature.svg';

// styles
import styles from './DonateSearchRow.module.scss'

export interface DonateSearchRowProps {
  stationData?: StationData;
}

function DonateSearchRow(props: DonateSearchRowProps) {
  const { stationData } = props;

  if (!stationData) {
    return null;
  }

  const { attributes } = stationData;
  const {
    donate_url,
    short_common_name,
  } = attributes;

  const donateUrl = donate_url ? donate_url : DONATE_FALLBACK_URL;
  const donateLinkText = `Donate to ${short_common_name}`;
  
  return (
    <div className={styles.donate_search_row}>
      <div className={styles.donate_search_row__content}>
        <StationLogo
          stationData={stationData}
          className={styles.donate_search_row__logo}
        />
        <p className={styles.donate_search_row__description}>
          Support your local PBS station in our mission to inspire, enrich, and educate.
        </p>
        <DonateLinkButton
          href={donateUrl}
          style="white"
          iconBefore="heart"
          target="_blank"
          className={styles.donate_search_row__button}
          gtmEventData={{
            feature_category: "donate search row",
            feature_name: "donate search row donate link",
            object_text: donateLinkText,
            object_url: donateUrl,
          }}
        >
          {donateLinkText}
        </DonateLinkButton>
      </div>
      <Image
        src={ExploringNature}
        alt="Support PBS"
        width={345}
        height={230}
        className={styles.donate_search_row__image}
      />
    </div>
  );
}

export default DonateSearchRow
